import /*React, */ { useState, useCallback, useEffect, useMemo, useRef } from "react";
import {
  ReactFlow,
  Background,
  Controls,
  PanOnScrollMode,
  applyNodeChanges,
  useNodesState,
  useEdgesState,
  ReactFlowProvider,
  } from "@xyflow/react";
import '@xyflow/react/dist/style.css';

import {
  leggiCoordinateX,
  leggiCoordinateY,
  aggiornaTavolo,
  claimTableSession,
  releaseTableSession,
  } from "../APIs/TablesAPI"
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getAllCategorie } from "../APIs/CategoriesAPI";
//Altre Pagine
import SelezioneComanda from "../pages/SelezionaComande";
//Material UI
import {
  Box,
  Divider,
  Button,
  Typography,
  Card,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  IconButton,
  Pagination,
  TextField,
  Grid,
  MenuItem,
  Paper,
  InputAdornment,
  CircularProgress
} from "@mui/material";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Select from './SearchableSelect';
//Icone
import { /* Add, */ Close, Notes, VisibilityOutlined } from "@mui/icons-material";
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import SearchIcon from '@mui/icons-material/Search';
// import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
// import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { spostaProdottiComanda, creaComanda, eliminaComanda, patchProdottoComanda } from "../APIs/OrdersAPI";
// import { current } from "@reduxjs/toolkit";
import ConfermaLiberaTavolo from "./confermaLiberaTavolo";
import { PrintEventListener } from "../utils/setupWSEventListener";
import { aggiornaStatusComanda } from "../APIs/OrdersAPI";
import { getAllSottocategorie } from "../APIs/SubCategoriesAPI";
import { draftPayment,printDocument,/* offlinePrintDocument */ } from "../APIs/PrintersAPI";
import { getTenantSettings } from "../APIs/TenantSettingsAPI";
import { buildKitchenTargets, normalizeKitchenLines } from "../utils/kitchenWorkflow";

import { getTenantTranslation } from "../utils/getTenantTranslation";

import { useSnackbar } from "../contexts/SnackBarContext";
import { usePermissions } from "../contexts/PermissionsContext";
import { ModalNotes } from "./modalNotes";
import { useNavigate } from "react-router-dom";
import {
  getFixedPriceMenuCourses,
  getTastingMenuCourses,
  isTastingMenuPackage,
} from "../utils/orderMenuDetails";

// import CustomSnackbar from "./CustomSnackbar";

const formatDateTime24 = (value) =>
  new Date(value).toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

const orderBelongsToTable = (order, tableId) => {
  const normalizedTableId = Number(tableId);
  if (!Number.isInteger(normalizedTableId) || normalizedTableId <= 0) return false;
  if (Number(order?.tableId ?? order?.table?.id) === normalizedTableId) return true;
  return (Array.isArray(order?.orderTables) ? order.orderTables : []).some((link) => (
    Number(link?.tableId ?? link?.table?.id) === normalizedTableId
  ));
};

const compareOrdersByCourse = (a, b) => {
  const aTime = new Date(a?.createdAt).getTime();
  const bTime = new Date(b?.createdAt).getTime();
  if (Number.isFinite(aTime) && Number.isFinite(bTime) && aTime !== bTime) return aTime - bTime;
  if (Number.isFinite(aTime) !== Number.isFinite(bTime)) return Number.isFinite(aTime) ? -1 : 1;
  return Number(a?.id || 0) - Number(b?.id || 0);
};

const formatQuantityWithUnit = (quantity, product) => {
  const qty = Number(quantity || 0);
  if (!product?.pricePerWeight) return `${qty}`;
  const unit = product?.typeOfWeight === 'HECTOGRAM' ? 'hg' : 'kg';
  return `${qty}${unit}`;
};

const PannelloDettagli = ({ tavoloId, tavoli, onClose, sx, categorie, sottoCategorie, onOpenComanda, onCanOpenTableOrder }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const { can } = usePermissions();
  const stylestatus = {
    fontSize: "14px",
    border: `1px solid #FFF`,
    borderRadius: "8px",
    paddingLeft: "16px",
    paddingRight: "16px",
    width: "100px",
    height: "40%",
    alignSelf: "anchor-center",
    mr: "16px",
  }
  const { showSnackbar } = useSnackbar();

  const token = localStorage.getItem('accessToken');
  const tenant = localStorage.getItem('tenantId');
  const tenantType = localStorage.getItem('tenantType');
  const [currentPage, setCurrentPage] = useState(null);
  const [openAccordions, setOpenAccordions] = useState([]);
  const [openLiberaTavolo, setOpenLiberaTavolo] = useState(false);
  // const limiteTempo = 6 * 1000 * 60 * 60 // 2 ore in ms
  const tableValue = []
  const [expanded, setExpanded] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openNote, setOpenNote] = useState(false)
  const [prodottoModale, setProdottoModale] = useState({})
  const [openEdit, setOpenEdit] = useState(false)
  const [editOrder, setEditOrder] = useState(null)
  const [editPriceOrder, setEditPriceOrder] = useState(null)
  const [editQtyOrder, setEditQtyOrder] = useState(null)

  const tavolo = useMemo(() => { return tavoli?.find(t => t.id === tavoloId) }, [tavoli, tavoloId]);
  // Filtra ordini che NON sono in stato 'CLOSED' o 'PAID'
  const tavoloFiltrato = useMemo(() => {
    return (tavolo?.ordersCreatedAt || [])
      .filter(ord => ord.status !== 'CLOSED' && ord.status !== 'PAID')
      .sort(compareOrdersByCourse);
  }, [tavolo]);

  const visualCourses = useMemo(() => {
    const tastingCourses = new Map();
    const fixedPriceCourses = new Map();

    const ensureTastingCourse = (courseIndex, courseName = "") => {
      if (!tastingCourses.has(courseIndex)) {
        tastingCourses.set(courseIndex, { courseIndex, courseName, items: [] });
      } else if (!tastingCourses.get(courseIndex).courseName && courseName) {
        tastingCourses.get(courseIndex).courseName = courseName;
      }
      return tastingCourses.get(courseIndex);
    };

    const ensureFixedPriceCourse = (courseIndex, courseName = "") => {
      if (!fixedPriceCourses.has(courseIndex)) {
        fixedPriceCourses.set(courseIndex, { courseIndex, courseName, items: [] });
      } else if (!fixedPriceCourses.get(courseIndex).courseName && courseName) {
        fixedPriceCourses.get(courseIndex).courseName = courseName;
      }
      return fixedPriceCourses.get(courseIndex);
    };

    tavoloFiltrato.forEach((order) => {
      (order.orderPackages || [])
        .filter(isTastingMenuPackage)
        .forEach((orderPackage) => {
          const packageName = orderPackage.package?.name || `Package #${orderPackage.packageId}`;
          getTastingMenuCourses(orderPackage).forEach((course) => {
            const targetCourse = ensureTastingCourse(course.courseIndex, course.courseName);
            course.items.forEach((item) => {
              targetCourse.items.push({ ...item, packageName });
            });
          });
        });

      (order.orderFixedPriceMenus || []).forEach((menu) => {
        const menuName = menu.menuNameSnapshot || t("fixedPriceMenu.menuFallback");
        getFixedPriceMenuCourses(menu).forEach((course) => {
          const targetCourse = ensureFixedPriceCourse(course.courseIndex, course.courseName);
          course.items.forEach((item) => {
            targetCourse.items.push({ ...item, menuName });
          });
        });
      });
    });

    const maxTastingCourse = Math.max(0, ...tastingCourses.keys());
    const maxFixedPriceCourse = Math.max(0, ...fixedPriceCourses.keys());
    const totalCourses = Math.max(tavoloFiltrato.length, maxTastingCourse, maxFixedPriceCourse);

    return Array.from({ length: totalCourses }, (_, index) => {
      const courseIndex = index + 1;
      const order = tavoloFiltrato[index] || null;
      const tastingCourse = tastingCourses.get(courseIndex);
      const fixedPriceCourse = fixedPriceCourses.get(courseIndex);
      return {
        id: order?.id ?? `virtual-course-${courseIndex}`,
        courseIndex,
        courseName: fixedPriceCourse?.courseName || tastingCourse?.courseName || "",
        order,
        orderIndex: order ? index : -1,
        tastingItems: tastingCourse?.items || [],
        fixedPriceItems: fixedPriceCourse?.items || [],
      };
    });
  }, [tavoloFiltrato, t]);

  useEffect(() => {
    if (visualCourses.length > 0 && visualCourses.length <= 3) {
      setOpenAccordions(visualCourses.map((course) => course.id));
    } else {
      setOpenAccordions([]); // per tavoli con >= 4 ordini, inizialmente chiusi
    }
  }, [visualCourses]);

  // Chiudi tutti i modali quando cambia il tavolo
  useEffect(() => {
    setOpenDelete(false);
    setOpenLiberaTavolo(false);
    setIdToDelete(null);
    setSelectedOrder(null);
  }, [tavoloId]);

  function matchCategory(categorie, idCategoria) {
    return categorie.find(cat => Number(cat.id) === Number(idCategoria))?.name
  }

  function getProductCategoryLabel(product) {
    const categoryEntries = Array.isArray(product?.categories) ? product.categories : [];
    const labels = categoryEntries
      .map((entry) => {
        const categoryId = Number(entry?.categoryId ?? entry?.category?.id);
        const subcategoryId = Number(entry?.subcategoryId ?? entry?.subcategory?.id);
        const categoryName = entry?.category?.name || matchCategory(categorie, categoryId);
        const subcategoryName = entry?.subcategory?.name || matchCategory(sottoCategorie, subcategoryId);

        if (categoryName && subcategoryName) return `${categoryName} - ${subcategoryName}`;
        return categoryName || subcategoryName || null;
      })
      .filter(Boolean);

    if (labels.length > 0) return [...new Set(labels)].join(", ");

    if (product?.categoryId) {
      const categoryName = matchCategory(categorie, Number(product.categoryId));
      const subcategoryName = product?.subcategoryId
        ? matchCategory(sottoCategorie, Number(product.subcategoryId))
        : null;
      if (categoryName && subcategoryName) return `${categoryName} - ${subcategoryName}`;
      if (categoryName) return categoryName;
    }

    return t("NoCategory");
  }

  function handleChangePage(_, value) {
    setCurrentPage(value)
    const idList = tableValue[value - 1].id
    setOpenAccordions([idList]);
  }

  const toggleAccordion = (id) => {
    setOpenAccordions((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
    setCurrentPage(null)
  };

  const handleClientAccordion = () => {
    setExpanded((prev) => !prev);
  };

  function getVariantIds(orderProduct) {
    if (Array.isArray(orderProduct?.variantIds)) {
      return orderProduct.variantIds
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0);
    }
    if (Array.isArray(orderProduct?.orderProductVariants)) {
      return orderProduct.orderProductVariants
        .map((opv) => Number(opv?.variantId ?? opv?.variant?.id))
        .filter((id) => Number.isInteger(id) && id > 0);
    }
    const single = Number(orderProduct?.variantId ?? orderProduct?.variant?.id);
    return Number.isInteger(single) && single > 0 ? [single] : [];
  }

  function getVariantNames(orderProduct) {
    if (!Array.isArray(orderProduct?.orderProductVariants)) return [];
    return orderProduct.orderProductVariants
      .map((opv) => opv?.variant?.name)
      .filter(Boolean);
  }

  function isSameProductLine(a, b) {
    if (Number(a?.productId) !== Number(b?.productId)) return false;
    const aIds = getVariantIds(a).sort((x, y) => x - y);
    const bIds = getVariantIds(b).sort((x, y) => x - y);
    if (aIds.length !== bIds.length) return false;
    return aIds.every((id, idx) => id === bIds[idx]);
  }

  const handleMoveProduct = async (ordineCorrenteIndex, product, direction) => {
    const ordiniVisibili = tavoloFiltrato;
    const ordineOrigine = ordiniVisibili[ordineCorrenteIndex];
    const ordineDestinazioneIndex = direction === 'up'
      ? ordineCorrenteIndex - 1
      : ordineCorrenteIndex + 1;
    const ordineDestinazione = ordiniVisibili[ordineDestinazioneIndex];

    if (!ordineOrigine || !ordineDestinazione) return;

    try {
      // rimuove prodotto dall'ordine di origine
      const prodottiOrigineAggiornati = ordineOrigine.orderProducts
        .filter((p) => Number(p.id) !== Number(product.id));

      if (prodottiOrigineAggiornati.length === 0) {
        await eliminaComanda(ordineOrigine.id, token, tenant);
      } else {
        await spostaProdottiComanda(
          ordineOrigine.id,
          prodottiOrigineAggiornati.map(p => ({
            productId: p.productId,
            variantIds: getVariantIds(p),
            quantity: p.quantity,
          })),
          token,
          tenant
        );
      }

      // aggiunge o incrementa prodotto nell'ordine di destinazione
      const prodottoEsistente = ordineDestinazione.orderProducts.find((p) => isSameProductLine(p, product));

      let prodottiDestinazioneAggiornati;
      if (prodottoEsistente) {
        prodottiDestinazioneAggiornati = ordineDestinazione.orderProducts.map(p =>
          isSameProductLine(p, product)
            ? { ...p, quantity: p.quantity + product.quantity }
            : p
        );
      } else {
        prodottiDestinazioneAggiornati = [
          ...ordineDestinazione.orderProducts,
          { productId: product.productId, variantIds: getVariantIds(product), quantity: product.quantity },
        ];
      }

      await spostaProdottiComanda(
        ordineDestinazione.id,
        prodottiDestinazioneAggiornati.map(p => ({
          productId: p.productId,
          variantIds: getVariantIds(p),
          quantity: p.quantity,
        })),
        token,
        tenant
      );
    } catch (error) {
      handleAlert(t("tableMapPage.error_move_product_1") + error.message, "error");
    }
  };

  const handleEdit = async (modificaOrdine) => {
    const ordine_modificato = {}
    ordine_modificato.orderProductId = modificaOrdine.id
    ordine_modificato.quantity = editQtyOrder
    ordine_modificato.unitPrice = parseFloat(editPriceOrder)
    patchProdottoComanda(modificaOrdine.orderId, ordine_modificato, token, tenant)
  };

  const handleDelete = async (tavoloFil) => {
    let deletingWholeOrder = false;
    try {
      const currentOrder = (Array.isArray(tavoloFil) ? tavoloFil : [])
        .find((order) => Number(order.id) === Number(selectedOrder));
      const remainingProducts = (Array.isArray(currentOrder?.orderProducts) ? currentOrder.orderProducts : [])
        .filter((product) => Number(product.id) !== Number(idToDelete));
      const hasPackages = (currentOrder?.orderPackages || []).some((row) => Number(row?.quantity || 0) > 0);
      const hasFixedPriceMenus = (currentOrder?.orderFixedPriceMenus || []).some((row) => Number(row?.quantity || 0) > 0);

      if (remainingProducts.length === 0 && !hasPackages && !hasFixedPriceMenus) {
        deletingWholeOrder = true;
        await eliminaComanda(selectedOrder, token, tenant);
        const remainingOrders = (Array.isArray(tavoloFil) ? tavoloFil : [])
          .filter((order) => Number(order.id) !== Number(selectedOrder))
          .filter((order) => (
            (order?.orderProducts || []).some((row) => Number(row?.quantity || 0) > 0)
            || (order?.orderPackages || []).some((row) => Number(row?.quantity || 0) > 0)
            || (order?.orderFixedPriceMenus || []).some((row) => Number(row?.quantity || 0) > 0)
          ));
        if (remainingOrders.length === 0 && tavolo?.id) {
          const nextStatus = tavolo?.hasPrenotazione ? 'RISERVATO' : 'LIBERO';
          await aggiornaTavolo(tavolo.id, { status: nextStatus, takenSeats: 0 }, token, tenant);
          await releaseTableSession(tavolo.id, token, tenant).catch(() => {});
        }
      } else {
        await patchProdottoComanda(selectedOrder, {
          orderProductId: Number(idToDelete),
          quantity: 0,
        }, token, tenant);
      }

      window.dispatchEvent(new CustomEvent('comanda-creata'));
      setSelectedOrder(null);
      setIdToDelete(null);
    } catch (error) {
      if (deletingWholeOrder) {
        handleAlert(t("tableMapPage.error_delete_order_1") + error.message, "error");
      } else {
        handleAlert(t("tableMapPage.error_patch_order_1") + error.message, "error");
      }
    }
  };

  function handleAlert(msg, type) {
    showSnackbar(msg, type)
  }

  function listaOrdiniFiltrati(tavFiltrato) {
    return (
      <>
        <Box justifyItems={"anchor-center"}>
          <Pagination
            count={visualCourses.length}
            page={currentPage || 0}
            onChange={handleChangePage}
            color="primary"
            variant="outlined"
            sx={{ mt: 2, mb: 2 }}
          />
        </Box>
        {
          visualCourses?.map((course) => {
            const ordine = course.order;
            const orderIndex = course.orderIndex;
            const isFirst = orderIndex <= 0;
            const isLast = orderIndex === tavFiltrato.length - 1;
            const isSingle = tavFiltrato.length === 1;

            // count++
            const obj = { "id": course.id }
            tableValue.push(obj)
            return (
              <Accordion
                key={course.id}
                id={course.id}
                variant="outlined"
                expanded={openAccordions.includes(course.id)}
                sx={{
                  borderRadius: 2,
                  marginBottom: 1,
                  minHeight: '74px',
                  alignItems: "center",
                  backgroundColor: theme.palette.accordion.backgroundColor,
                  border: theme.palette.accordion.border
                }}
              >
                <AccordionSummary>
                  <Box paddingY={1.5} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Typography>{course.courseIndex} - {course.courseName || t("tableMapPage.course")}</Typography>
                    {openAccordions.includes(course.id) ?
                      (<Typography onClick={() => toggleAccordion(course.id)} sx={{ display: "flex", alignItems: "center", gap: 0.5, color: theme.palette.accordion.color }}>
                        {t("tableMapPage.close").toUpperCase()}<ExpandLessIcon />
                      </Typography>)
                      :
                      (<Typography onClick={() => toggleAccordion(course.id)} sx={{ display: "flex", alignItems: "center", gap: 0.5, color: theme.palette.accordion.color }}>
                        {t("tableMapPage.details").toUpperCase()}<ExpandMoreIcon />
                      </Typography>)
                    }
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  {
                    (ordine?.orderProducts || []).map(
                      (prodotto) => (
                        <Box
                          key={prodotto.id || `${prodotto.orderId}-${prodotto.productId}-${getVariantIds(prodotto).join('-') || 'base'}`}
                          sx={{
                            // minHeight: '90px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            mb: 1,
                            p: 2,
                            pt: 2,
                            pb: 2,
                            border: theme.palette.accordion.border,
                            borderRadius: '4px',
                            backgroundColor: theme.palette.background.default,
                          }}
                        >
                          {/* <Box>
                          </Box> */}
                          <Box alignContent={"center"} display={"flex"} gap={1}>
                            <Box alignContent={"center"} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                              {/* per Spostare alla comanda superiore il prodotto */}
                              <IconButton
                                size='small'
                                color="default"
                                disabled={isFirst || isSingle}
                                sx={{ p: 0.3, '& svg': { fontSize: 16 } }}
                                onClick={() => { handleMoveProduct(orderIndex, prodotto, 'up') }}
                              >
                                <KeyboardArrowUpOutlinedIcon />
                              </IconButton>

                              {/* per Spostare alla comanda inferiore il prodotto */}
                              <IconButton
                                size='small'
                                color="default"
                                disabled={isLast || isSingle}
                                sx={{ p: 0.3, '& svg': { fontSize: 16 } }}
                                onClick={() => { handleMoveProduct(orderIndex, prodotto, 'down') }}
                              >
                                <KeyboardArrowDownOutlinedIcon />
                              </IconButton>
                            </Box>
                            <Box>
                              <Typography variant="body2" pt={'1px'} pb={'1px'} fontWeight={"bold"}>
                                {getProductCategoryLabel(prodotto.product)}
                              </Typography>
                              <Typography variant="body2" pt={'1px'} pb={'1px'} fontStyle={"italic"} >
                                (x{formatQuantityWithUnit(prodotto.quantity, prodotto.product)}){prodotto.product.name}
                                {getVariantNames(prodotto).length > 0 ? ` + ${getVariantNames(prodotto).join(' + ')}` : ''}
                              </Typography>
                            </Box>
                          </Box>
                          <Box alignContent={"center"} sx={{ display: 'flex', justifyContent: 'space-between', }}>
                            <Typography variant="body2" padding={1} fontWeight={"bold"} alignContent={"center"}>
                              € {(prodotto.unitPrice * prodotto.quantity).toFixed(2)}
                            </Typography>
                            <IconButton onClick={() => {
                              setProdottoModale(prodotto);
                              setOpenNote(true);
                            }}>
                              <Notes />
                            </IconButton>
                            <IconButton size='small' color="default" onClick={() => {
                              setOpenEdit(true)
                              setEditOrder(prodotto)
                              setEditPriceOrder(prodotto.unitPrice)
                              setEditQtyOrder(prodotto.quantity)

                            }}><ModeEditOutlinedIcon /></IconButton>
                            <IconButton size='small' color="error" onClick={() => {
                              setOpenDelete(true)
                              setIdToDelete(prodotto.id)
                              setSelectedOrder(prodotto.orderId)

                            }}><DeleteOutlineOutlinedIcon /></IconButton>
                          </Box>
                        </Box>
                      )
                    )
                  }
                  {
                    (ordine?.orderPackages || [])
                      .filter((orderPackage) => !isTastingMenuPackage(orderPackage))
                      .map((orderPackage) => (
                      <Box
                        key={`pkg-${ordine.id}-${orderPackage.packageId}`}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          mb: 1,
                          p: 2,
                          pt: 2,
                          pb: 2,
                          border: theme.palette.accordion.border,
                          borderRadius: '4px',
                          backgroundColor: theme.palette.background.default,
                        }}
                      >
                        <Box alignContent={"center"} display={"flex"} gap={1}>
                          <Box>
                            <Typography variant="body2" pt={'1px'} pb={'1px'} fontWeight={"bold"}>
                              {isTastingMenuPackage(orderPackage)
                                ? t("orderPackages.tastingMenu")
                                : t("orderPackages.label")}
                            </Typography>
                            <Typography variant="body2" pt={'1px'} pb={'1px'} fontStyle={"italic"}>
                              (x{orderPackage.quantity}){orderPackage.package?.name || `Package #${orderPackage.packageId}`}
                            </Typography>
                          </Box>
                        </Box>
                        <Box alignContent={"center"} sx={{ display: 'flex', justifyContent: 'space-between', }}>
                          <Typography variant="body2" padding={1} fontWeight={"bold"} alignContent={"center"}>
                            € {((Number(orderPackage.unitPrice || 0)) * (Number(orderPackage.quantity || 0))).toFixed(2)}
                          </Typography>
                          <IconButton onClick={() => {
                            setProdottoModale({
                              ...orderPackage,
                              product: { name: orderPackage.package?.name || `Package #${orderPackage.packageId}` },
                            });
                            setOpenNote(true);
                          }}>
                            <Notes />
                          </IconButton>
                        </Box>
                      </Box>
                    ))
                  }
                  {course.tastingItems.map((item, itemIndex) => (
                    <Box
                      key={`tasting-${course.courseIndex}-${item.name}-${item.variantName}-${itemIndex}`}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mb: 1,
                        p: 2,
                        border: `1px dashed ${theme.palette.primary.main}`,
                        borderRadius: '4px',
                        backgroundColor: theme.palette.background.default,
                      }}
                    >
                      <Box>
                        <Typography variant="body2" fontWeight="bold">
                          {t("orderPackages.tastingMenu")} - {course.courseName || `${t("tableMapPage.course")} ${course.courseIndex}`}
                        </Typography>
                        <Typography variant="body2" fontStyle="italic">
                          (x{item.quantity}){item.name}
                          {item.variantName ? ` + ${item.variantName}` : ""}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {item.packageName}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                  {course.fixedPriceItems.map((item, itemIndex) => (
                      <Box
                        key={`fixed-menu-${course.courseIndex}-${item.id || itemIndex}`}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          mb: 1,
                          p: 2,
                          border: `1px dashed ${theme.palette.warning.main}`,
                          borderRadius: '4px',
                          backgroundColor: theme.palette.background.default,
                        }}
                      >
                        <Box>
                          <Typography variant="body2" fontWeight="bold">
                            {item.menuName} - {course.courseName || `${t("tableMapPage.course")} ${course.courseIndex}`}
                          </Typography>
                          <Typography variant="body2" fontStyle="italic">
                            (x{item.quantity}){item.name}
                          </Typography>
                          {item.extraPrice > 0 && (
                            <Typography variant="caption" color="text.secondary">
                              {t("fixedPriceMenu.supplementLabel", { price: item.extraPrice.toFixed(2) })}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    ))}
                </AccordionDetails>
              </Accordion>
            )
          })}
      </>
    )
  }

  const liberaTavolo = (tavolo) => {
    const token = localStorage.getItem("accessToken");
    const tenant = localStorage.getItem("tenantId");
    aggiornaTavolo(tavolo.id, { status: "IN_ATTESA" }, token, tenant);
  }

  const handleChangePrice = (event) => {
    const newValue = event.target.value;
    if (/^\d*\.?\d{0,2}$/.test(newValue)) {
      setEditPriceOrder(newValue);
    }
  };

  const handleChangeQty = (event) => {
    const newValue = event.target.value;
    if (/^\d*\.?\d{0,2}$/.test(newValue)) {
      setEditQtyOrder(newValue);
    }
  };

  function closeEditOrder() {
    setEditOrder(false)
    setOpenEdit(false)
    setEditPriceOrder(null)
    setEditQtyOrder(null)
  }

  function changeQty(operation) {
    if (operation === "-") if (editQtyOrder > 1) setEditQtyOrder(parseInt(editQtyOrder) - 1)
    else if (operation === "+") setEditQtyOrder(parseInt(editQtyOrder) + 1)
  }

  function changePrice(operation) {
    if (operation === "-") {
      if (editPriceOrder > 1) setEditPriceOrder((parseFloat(editPriceOrder) - 1).toFixed(2))
      if (editPriceOrder <= 1) setEditPriceOrder((0.01).toFixed(2))
    }
    else if (operation === "+") setEditPriceOrder((parseFloat(editPriceOrder) + 1).toFixed(2))
  }

  const noClientLabel = t('reservations_details.noClient');
  const hasClientName = Boolean(
    tavolo?.nomeCliente &&
    String(tavolo.nomeCliente).trim() !== "" &&
    String(tavolo.nomeCliente) !== noClientLabel
  );
  const showClientDetails = Boolean(
    tavolo?.hasPrenotazione && (tavolo?.hasClientePrenotazione || hasClientName)
  );
  const clientTreatmentValue = (tavolo?.clientTreatment || 'cliente');

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "470px" },
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        height: { xs: "auto", md: "643px" }, // stessa altezza del box tavoli
        maxHeight: { xs: "70dvh", md: "643px" },
        p: { xs: 2, md: 3 },
        ml: { xs: 0, md: 2 },
        borderRadius: '8px',
        border: theme.palette.accordion.border,
        backgroundColor: theme.pannelloDettagli.backgroundColor,
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
    >{/*WIP*/}
      <Box flexGrow={1} paddingRight={{ xs: 0, md: "6px" }} sx={{
        minWidth: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: theme.pannelloDettagli.backgroundColor
      }} >
        {tavolo ? (
          <>
            <Box display={"flex"} justifyContent={"space-between"}>
              <Box display={"flex"} alignContent={"start"} gap={1}>
                <Typography variant="h6" gutterBottom>
                  {getTenantTranslation(t, tenantType, 'selected_table') + ": "}
                </Typography>
                <Typography variant="h6" gutterBottom>
                  {tavolo.name}
                </Typography>
              </Box>
              <IconButton onClick={onClose} sx={{
                background: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);",
                '&:hover': {
                  opacity: 0.7,
                  background: theme.palette.primary.main,
                }
              }}>
                <Close />
              </IconButton>
            </Box>
            {tavolo.note && (
              <Typography variant="body2" sx={{ mb: 1, fontStyle: 'italic' }}>
                {t('notes')}: {tavolo.note}
              </Typography>
            )}
            {showClientDetails ? (
              <Accordion
                variant="outlined"
                expanded={expanded}
                onClick={handleClientAccordion}
                sx={{
                  borderRadius: 1,
                  marginTop: 1,
                  minHeight: '74px',
                  alignItems: "center",
                  border: theme.palette.accordion.border,
                  backgroundColor: theme.palette.accordion.backgroundColor
                }}>
                <AccordionSummary>
                  <Box paddingY={1.5} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Typography>{t("reservations_details.clientDetails")}</Typography>

                    {expanded ?
                      (<Typography sx={{ display: "flex", alignItems: "center", gap: 0.5, color: theme.palette.accordion.color }}>
                        {t("tableMapPage.close").toUpperCase()}<ExpandLessIcon />
                      </Typography>)
                      :
                      (<Typography sx={{ display: "flex", alignItems: "center", gap: 0.5, color: theme.palette.accordion.color }}>
                        {t("tableMapPage.open").toUpperCase()}<ExpandMoreIcon />
                      </Typography>)
                    }
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Box
                    display={"flex"}
                    justifyContent={"space-between"}
                    sx={{
                      width: "100%",
                      background: theme.palette.detailViewBox.background,
                      border: theme.palette.detailViewBox.border
                    }}>
                    <Box padding={"16px"}>
                      <Typography>{tavolo.nomeCliente}</Typography>
                      <Typography variant="caption" sx={{ opacity: 0.85 }}>
                        {`Ore: ${tavolo.oraPrenotazione}`}
                      </Typography>
                    </Box>
                    <Box
                      color={'black'}
                      display={"flex"}
                      alignItems={'center'}
                      justifyContent={'center'}
                      sx={{
                        ...stylestatus,
                        background:
                          theme.palette.mode === 'light'
                            ? (clientTreatmentValue === 'cliente'
                              ? '#D8FFE5'
                              : '#FFD4A2')
                            : (clientTreatmentValue === 'cliente'
                              ? '#3F4942'
                              : '#88571E')
                      }}
                    >
                      <Typography>
                        {t(clientTreatmentValue)}
                      </Typography>
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
            ) : (tavolo.status === "LIBERO" || tavolo.hasPrenotazione) ? (
              <Box sx={{
                borderRadius: 1,
                marginTop: 1,
                minHeight: "74px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 1.5,
                border: theme.palette.accordion.border,
                backgroundColor: theme.palette.accordion.backgroundColor
              }}>
                <Typography variant="h5" color="text.secondary" textAlign="center" sx={{ fontSize: { xs: "1.1rem", md: "1.5rem" } }}>
                  {t('reservations_details.noClient')}
                </Typography>
              </Box>
            ) : null}
            {/* mappa di ordersCreatedAt per nascondere ordini "scaduti" */}

            <Box sx={{ mb: 2 }}>
              {tavolo.status === "LIBERO" && tavoloFiltrato.length > 0 ?
                (
                  <>
                    <Box sx={{ height: 8 }} />
                    <Box
                      sx={{
                        borderRadius: 1,
                        marginTop: 1,
                        minHeight: "74px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        px: 1.5,
                        border: theme.palette.accordion.border,
                        backgroundColor: theme.palette.accordion.backgroundColor
                      }}>
                      <Typography variant="h5" color="text.secondary" textAlign="center" sx={{ fontSize: { xs: "1.1rem", md: "1.5rem" } }}>
                        {t('reservations_details.noOrder')}
                      </Typography>

                    </Box>
                  </>
                ) : tavoloFiltrato && tavoloFiltrato.length > 0 ?
                  (
                    <>
                      {listaOrdiniFiltrati(tavoloFiltrato)}
                      {/* Pop-Up per modificare Prezzo e Quantità dei prodotti nella comanda */}
                      <Dialog open={openDelete} onClose={() => {
                        setOpenDelete(false)
                        setIdToDelete(null)
                        setSelectedOrder(null)
                      }}>
                        <DialogTitle>
                          {t('confirmOperation.deleteProduct')}
                        </DialogTitle>
                        <DialogActions>
                          <Button variant="outlined" onClick={() => {
                            setOpenDelete(false)
                            setIdToDelete(null)
                            setSelectedOrder(null)
                          }}>
                            {t('confirmOperation.cancel')}
                          </Button>
                          <Button variant="contained" onClick={() => {
                            handleDelete(tavoloFiltrato)
                            setOpenDelete(false)
                          }}>
                            {t('confirmOperation.confirm')}
                          </Button>
                        </DialogActions>
                      </Dialog>
                      {/* Pop-Up per modificare Prezzo e Quantità dei prodotti nella comanda */}
                      <Dialog open={openEdit} onClose={() => { closeEditOrder() }}>
                        <DialogTitle>
                          {t('confirmOperation.editOrder')}
                        </DialogTitle>
                        <DialogContent>
                          {/* modifica quantità */}
                          <Box display={"flex"} sx={{ my: 1 }}>
                            <Button variant="contained" sx={{ borderRadius: 0 }} onClick={() => { changeQty("-") }}>
                              <Typography fontSize={"18px"}>-</Typography>
                            </Button>
                            <TextField
                              label={t("Quantità")}
                              type="number"
                              value={editQtyOrder}
                              onChange={handleChangeQty}
                              inputProps={{
                                inputMode: "decimal"
                              }}
                              sx={{ borderRadius: 0, textAlignLast: "center" }}
                            />
                            <Button variant="contained" sx={{ borderRadius: 0 }} onClick={() => { changeQty("+") }}>
                              <Typography fontSize={"18px"}>+</Typography>
                            </Button>
                          </Box>
                          {/* modifica prezzo */}
                          <Box display={"flex"} sx={{ my: 1 }}>
                            <Button variant="contained" sx={{ borderRadius: 0 }} onClick={() => { changePrice("-") }}>
                              <Typography fontSize={"12px"}>-1,00</Typography>
                            </Button>
                            <TextField
                              label={t("Prezzo")}
                              type="number"
                              value={editPriceOrder}
                              onChange={handleChangePrice}
                              inputProps={{
                                inputMode: "decimal",
                              }}
                              sx={{ borderRadius: 0, textAlignLast: "center" }}
                            />
                            <Button variant="contained" sx={{ borderRadius: 0 }} onClick={() => { changePrice("+") }}><Typography fontSize={"12px"}>+1,00</Typography></Button>
                          </Box>
                        </DialogContent>
                        <DialogActions>
                          <Button variant="outlined" onClick={() => { closeEditOrder() }}>
                            {t('confirmOperation.cancel')}
                          </Button>
                          <Button variant="contained" onClick={() => {
                            handleEdit(editOrder)
                            closeEditOrder()
                          }}>
                            {t('confirmOperation.confirm')}
                          </Button>
                        </DialogActions>
                      </Dialog>

                      {openNote &&
                        <ModalNotes
                          open={openNote}
                          onClose={() => {
                            setOpenNote(false);
                            setProdottoModale({});
                          }}
                          prodotto={prodottoModale}
                          note={prodottoModale.note}
                          readOnly
                        />
                      }
                    </>
                  )
                  :
                  (
                    <>
                      <Box sx={{ height: 8 }} />
                      <Box
                        sx={{
                          borderRadius: 1,
                          marginTop: 1,
                          minHeight: "74px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          px: 1.5,
                          border: theme.palette.accordion.border,
                          backgroundColor: theme.palette.accordion.backgroundColor
                        }}>
                        <Typography variant="h5" color="text.secondary" textAlign="center" sx={{ fontSize: { xs: "1.1rem", md: "1.5rem" } }}>
                          {t('reservations_details.noOrder')}
                        </Typography>

                      </Box>
                    </>
                  )
              }
            </Box>
          </>
        ) : (
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "text.secondary",
            }}
          >
            <Typography variant="h6" textAlign={"center"}>
              {t("noTableSelected")}
            </Typography>
          </Box>
        )}
      </Box>

      <Divider sx={{ my: 2 }} />
      <Box display={'flex'} flexDirection={{ xs: 'column', sm: 'row' }} gap={1} sx={{ minWidth: 0 }}>
        <Button
          disabled={!tavolo || tavolo.status === "NON_DISPONIBILE"}
          variant="contained"
          onClick={async () => {
            if (!tavolo) return;
            if (onCanOpenTableOrder) {
              const canOpen = await onCanOpenTableOrder(tavolo);
              if (!canOpen) return;
            }
            onOpenComanda();
          }}
          sx={{ mt: "auto", flexGrow: 2, minWidth: 0, width: { xs: "100%", sm: "auto" }, whiteSpace: "normal" }}
        >
          {getTenantTranslation(t, tenantType, 'newOrder')}
        </Button>
        <Button disabled={!tavolo || tavolo.status !== "OCCUPATO"}
          variant="outlined"
          onClick={async () => {
            if (!tavolo || tavolo.status !== "OCCUPATO") return;
            try {
              await aggiornaTavolo(Number(tavolo.id), { status: "IN_ATTESA" }, token, tenant);
              window.dispatchEvent(new CustomEvent('map-data-changed'));
              window.dispatchEvent(new CustomEvent('comanda-creata'));
              if (String(tenantType || '').toUpperCase() === 'RISTORANTE' && !can('receipts:manage')) {
                navigate('/mappa_tavoli', { replace: true });
                return;
              }
              navigate(`/punto_cassa?tableId=${Number(tavolo.id)}`, {
                state: { checkoutTableId: Number(tavolo.id) }
              });
            } catch (err) {
              handleAlert(err?.message || String(err), "error");
            }
          }}
          sx={{ mt: 'auto', flexGrow: 1, minWidth: 0, width: { xs: "100%", sm: "auto" }, whiteSpace: "normal" }}
        >
          {t('tableMapPage.sendToCheckout')}
        </Button>
      </Box>

      {/* Modale conferma liberazione tavolo */}
      <ConfermaLiberaTavolo
        open={openLiberaTavolo}
        tavolo={tavolo?.name}
        onConferma={() => {
          tavoloFiltrato.forEach(ordTav => {
            if (ordTav.status !== "CLOSED") {
              aggiornaStatusComanda(ordTav.id, { status: "CLOSED" }, token, tenant);
            }
          });
          liberaTavolo(tavolo);
          setOpenLiberaTavolo(false);
        }}
        onAnnulla={() => setOpenLiberaTavolo(false)}
      />
    </Box>
  );
};

const TavoloNode = ({ data }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { tavolo, onSelect, getColor, hideButton } = data;
  const tenantType = localStorage.getItem('tenantType');

  return (
    <Card
      sx={{
        display: "flex",
        width: { xs: "128px", sm: "118px", md: "103.558px" },
        minHeight: { xs: "98px", sm: "90px", md: "79.558px" },
        maxHeight: { xs: "154px", sm: "145px", md: "133.558px" },
        padding: { xs: "7px", md: "5px" },
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        color: theme.palette.primary.contrastText,
        backgroundColor: getColor(tavolo.status),
      }}
    >
      <Typography
        variant="caption"
        sx={{
          textAlign: "center",
          fontFamily: "Helvetica Neue",
          fontSize: { xs: "12px", md: "10.83px" },
          fontWeight: "700",
          lineHeight: "175%",
          letterSpacing: "0.217px",
        }}
      >
        {tavolo.name}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          textAlign: "center",
          fontFamily: "Helvetica Neue",
          fontSize: { xs: "11px", md: "10.83px" },
          fontWeight: "500",
          lineHeight: "175%",
          letterSpacing: "0.217px",
        }}
      >
        {t(tavolo.status)}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          textAlign: "center",
          fontFamily: "Helvetica Neue",
          fontSize: { xs: "9px", md: "8px" },
          fontWeight: "500",
          lineHeight: "175%",
          letterSpacing: "0.217px",
        }}
      >
        {tavolo.status === "LIBERO" ? (getTenantTranslation(t, tenantType, "seatNumber") + ": " + tavolo.maxSeats) : (getTenantTranslation(t, tenantType, "occupiedSeats") + ": " + tavolo.takenSeats + "/" + tavolo.maxSeats)}
      </Typography>
      {!hideButton &&
        <Button
          variant="contained"
          size="small"
          sx={{
            display: "flex",
            padding: "5.415px",
            justifyContent: "center",
            alignItems: "center",
            gap: "5.415px",
            alignSelf: "stretch",
            color: theme.palette.text.primary,
            background:
              theme.palette.mode === "light" ? "#E9F3FF" : "#192F49",
          }}
          onClick={() => onSelect(tavolo)}
        >
          {t("showDetails")}
          <VisibilityOutlined sx={{ fontSize: "10px", ml: 0.5 }} />
        </Button>}
    </Card>
  );
};

const MobileTavoloCard = ({ tavolo, selected, onSelect, getColor }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const tenantType = localStorage.getItem('tenantType');

  return (
    <Card
      onClick={() => onSelect(tavolo)}
      sx={{
        p: 1.25,
        minHeight: 116,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        cursor: "pointer",
        color: theme.palette.primary.contrastText,
        backgroundColor: getColor(tavolo.status),
        border: selected ? `3px solid ${theme.palette.primary.main}` : "1px solid rgba(255,255,255,0.35)",
        boxShadow: selected ? `0 0 0 2px ${theme.palette.primary.contrastText}` : "none",
      }}
    >
      <Box>
        <Typography fontWeight={800} fontSize="0.95rem" lineHeight={1.2} noWrap>
          {tavolo.name}
        </Typography>
        <Typography fontWeight={700} fontSize="0.82rem" sx={{ mt: 0.5 }}>
          {t(tavolo.status)}
        </Typography>
        <Typography fontSize="0.75rem" sx={{ mt: 0.5 }}>
          {tavolo.status === "LIBERO"
            ? `${getTenantTranslation(t, tenantType, "seatNumber")}: ${tavolo.maxSeats}`
            : `${getTenantTranslation(t, tenantType, "occupiedSeats")}: ${tavolo.takenSeats}/${tavolo.maxSeats}`}
        </Typography>
      </Box>

      <Button
        variant="contained"
        size="small"
        sx={{
          mt: 1,
          minHeight: 34,
          fontWeight: 800,
          color: theme.palette.text.primary,
          background: theme.palette.mode === "light" ? "#E9F3FF" : "#192F49",
        }}
      >
        {t("showDetails")}
        <VisibilityOutlined sx={{ fontSize: 14, ml: 0.5 }} />
      </Button>
    </Card>
  );
};

const nodeTypes = {
  tavoloNode: TavoloNode,
};

const VistaDettagliata = ({ tavoliVisibili, getColor, allTables = [], onCanOpenTableOrder }) => {
  const [selectedTavolo, setSelectedTavolo] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [isSavingLayout, setIsSavingLayout] = useState(false);
  const [nodes, setNodes] = useNodesState([]);
  const [editNodes, setEditNodes] = useNodesState([]);
  const [edges, ,] = useEdgesState([]); // nessuna connessione
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isCompactDetailed = useMediaQuery(theme.breakpoints.down("md"));
  const hasCoarsePointer = useMediaQuery("(any-pointer: coarse)");
  const { showSnackbar } = useSnackbar();
  const [categorie, setCategorie] = useState([])
  const [sottoCategorie, setSottoCategorie] = useState([])
  const [openComanda, setOpenComanda] = useState(false);
  const [openTransfer, setOpenTransfer] = useState(false);
  const [selectedTransferTo, setSelectedTransferTo] = useState("");
  const [openTransferConfirm, setOpenTransferConfirm] = useState(false);
  const [pendingTransferOrderItem, setPendingTransferOrderItem] = useState(null);
  const [isTransferringOrder, setIsTransferringOrder] = useState(false);
  const transferLockRef = useRef(false);
  const mainFlowRef = useRef(null);
  const editFlowRef = useRef(null);
  const mainLockedYRef = useRef(null);
  const syncingMainViewportRef = useRef(false);
  const isMainAutoFittingRef = useRef(false);
  const prevMainNodesCountRef = useRef(null);
  const prevMainNodesSignatureRef = useRef("");
  const coordinatesCacheRef = useRef(new Map());

  const [searchOrders, setSearchOrders] = useState("");

  const token = localStorage.getItem('accessToken');
  const tenant = localStorage.getItem('tenantId');

  const getVariantIdsForOrderProduct = (orderProduct) => {
    if (Array.isArray(orderProduct?.variantIds)) {
      return orderProduct.variantIds
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0);
    }
    if (Array.isArray(orderProduct?.orderProductVariants)) {
      return orderProduct.orderProductVariants
        .map((opv) => Number(opv?.variantId ?? opv?.variant?.id))
        .filter((id) => Number.isInteger(id) && id > 0);
    }
    const single = Number(orderProduct?.variantId ?? orderProduct?.variant?.id);
    return Number.isInteger(single) && single > 0 ? [single] : [];
  };

  // Filtra solo ordini attivi del tavolo selezionato
  const tavoloFiltrato = useMemo(() => {
    const today = formatDate(new Date());
    return (tavoliVisibili || [])
      .find(tav => tav.id === selectedTavolo?.id)
      ?.ordersCreatedAt
      ?.filter((ord) =>
        ord &&
        ord.status !== "CLOSED" &&
        ord.status !== "PAID" &&
        orderBelongsToTable(ord, selectedTavolo?.id) &&
        formatDate(ord.createdAt) === today
      )
      ?.sort(compareOrdersByCourse)
      ?.flatMap(ord => ord.orderProducts) || [];
  }, [tavoliVisibili, selectedTavolo?.id]);

  const tavoliDettagliati = useMemo(() => (Array.isArray(tavoliVisibili) ? tavoliVisibili : []), [tavoliVisibili]);

  useEffect(() => {
    let isCancelled = false;

    const getCategorie = async () => {
      try {
        const [cat, subcat] = await Promise.all([
          getAllCategorie(token, tenant),
          getAllSottocategorie(token, tenant)
        ]);
        if (isCancelled) return;
        setCategorie(cat);
        setSottoCategorie(subcat);
      } catch (error) {
        if (isCancelled) return;
        showSnackbar(t("tableMapPage.error_categories_1") + error.message, "error");
      }
    };

    const buildNodesWithCoordinates = async () => {
      const list = Array.isArray(tavoliVisibili) ? tavoliVisibili : [];
      // Render immediato con cache/posizione locale per evitare ritardi UI.
      const immediateNodes = list.map((tb, i) => {
        const cached = coordinatesCacheRef.current.get(tb.id);
        const x = Number.isFinite(cached?.x)
          ? cached.x
          : (Number.isFinite(tb?.posX) ? tb.posX : 100 + i * 120);
        const y = Number.isFinite(cached?.y)
          ? cached.y
          : (Number.isFinite(tb?.posY) ? tb.posY : 100);
        return {
          id: tb.id.toString(),
          type: "tavoloNode",
          position: { x, y },
          data: { tavolo: tb, onSelect: setSelectedTavolo, getColor, hideButton: false },
        };
      });
      if (!isCancelled) setNodes(immediateNodes);

      // Carica coordinate remote solo per tavoli non presenti in cache.
      const missing = list.filter((tb) => !coordinatesCacheRef.current.has(tb.id));
      if (missing.length === 0) return;

      const fetched = await Promise.all(
        missing.map(async (tb, i) => {
          try {
            const [coordX, coordY] = await Promise.all([
              leggiCoordinateX(tb.id, token, tenant),
              leggiCoordinateY(tb.id, token, tenant),
            ]);
            const fallbackX = Number.isFinite(tb?.posX) ? tb.posX : 100 + i * 120;
            const fallbackY = Number.isFinite(tb?.posY) ? tb.posY : 100;
            const x = Number.isFinite(coordX?.value) ? coordX.value : fallbackX;
            const y = Number.isFinite(coordY?.value) ? coordY.value : fallbackY;
            return { id: tb.id, x, y };
          } catch (_) {
            return null;
          }
        })
      );

      if (isCancelled) return;
      const valid = fetched.filter(Boolean);
      if (valid.length === 0) return;

      valid.forEach((c) => coordinatesCacheRef.current.set(c.id, { x: c.x, y: c.y }));
      setNodes((prev) =>
        prev.map((n) => {
          const c = coordinatesCacheRef.current.get(Number(n.id));
          if (!c) return n;
          if (n.position.x === c.x && n.position.y === c.y) return n;
          return { ...n, position: { x: c.x, y: c.y } };
        })
      );
    };

    buildNodesWithCoordinates();
    getCategorie();

    return () => {
      isCancelled = true;
    };
  }, [tavoliVisibili, token, tenant, getColor, setNodes, t, showSnackbar]);

  // Sincronizza tavolo selezionato con dati aggiornati dal parent
  useEffect(() => {
    if (!selectedTavolo) return;
    const updated = tavoliDettagliati?.find(t => t.id === selectedTavolo.id);
    if (updated) {
      setSelectedTavolo(updated);
      nodeTypes.tavoloNode.data = { ...nodeTypes.tavoloNode.data, tavolo: updated, getColor, hideButton: false };
    } else {
      setSelectedTavolo(null);
    }
  }, [selectedTavolo, tavoliDettagliati, getColor]);

  // Riposiziona vista në hapjen e parë / ndryshim liste tavolinash që të mos dalin të prera.

  // Listener per evento print_failed
  useEffect(() => {
    const handlePrintError = (message) => {
      showSnackbar(message, "error");
    };
    const cleanup = PrintEventListener(handlePrintError);
    return cleanup;
  }, [showSnackbar]);

  const handleSave = async () => {
    if (isSavingLayout) return;
    const token = localStorage.getItem('accessToken');
    const tenant = localStorage.getItem('tenantId');

    try {
      setIsSavingLayout(true);
      const currentNodesById = new Map(nodes.map((n) => [n.id, n]));
      const changedNodes = editNodes.filter((node) => {
        const current = currentNodesById.get(node.id);
        if (!current) return true;
        return current.position.x !== node.position.x || current.position.y !== node.position.y;
      });

      if (changedNodes.length > 0) {
        await Promise.all(
          changedNodes.map((node) =>
            aggiornaTavolo(
              node.data.tavolo.id,
              { posX: node.position.x, posY: node.position.y },
              token,
              tenant
            )
          )
        );
      }

      setNodes([...editNodes]);
      editNodes.forEach((node) => {
        coordinatesCacheRef.current.set(Number(node.id), {
          x: node.position.x,
          y: node.position.y,
        });
      });
      handleAlert(t("tableMapPage.success_savedCoordinates"), "success");
      window.dispatchEvent(new Event('map-data-changed'));
      setEditOpen(false);
    } catch (error) {
      handleAlert(t("tableMapPage.error_coordinates_table_2") + error.message, "error");
    } finally {
      setIsSavingLayout(false);
    }
  };

  const handleOpenEdit = () => {
    // clono i nodi per evitare il polling dei tavoli durante l'editing
    setEditNodes(nodes.map((node) => ({
      ...node,
      position: { ...node.position },
      data: { ...node.data },
    })));
    setEditOpen(true);
  };

  const handlePrint = async () => {
    const activeOrders = (selectedTavolo?.ordersCreatedAt || [])
      .filter((order) => order.status !== 'CLOSED' && order.status !== 'PAID')
      .sort(compareOrdersByCourse);
    if (!activeOrders.length) {
      handleAlert(t('reservations_details.noOrder'), "warning");
      return;
    }

    try {
      const settings = await getTenantSettings(token, tenant);
      const lines = normalizeKitchenLines(activeOrders, {
        showFixedMenuName: settings?.showFixedMenuNameOnKitchenPrint === true,
        roomId: selectedTavolo?.roomId ?? selectedTavolo?.room?.id,
      });
      const { targets: printTargets, unassignedItems } = buildKitchenTargets(lines, {
        tableName: selectedTavolo?.name,
        tableNote: selectedTavolo?.note,
        customerLabel: selectedTavolo?.nomeCliente,
        isReprint: true,
        fontSize: settings?.orderPrintFontSize || 'NORMAL',
      });
      if (unassignedItems.length > 0) {
        handleAlert(`Stampa bloccata: prodotti senza stampante associata (${unassignedItems.slice(0, 5).join(', ')})`, "error");
        return;
      }
      if (!printTargets.length) {
        handleAlert('Nessuna stampante articolo configurata', "error");
        return;
      }
      const payload = { targets: printTargets, action: 'print_reprint' }
      const stampa = await printDocument(payload, token, tenant);
      if (!stampa.success) {
        // const stampaOffline = await offlinePrintDocument({ roomId: roomId, payload: tableProducts }, token, tenant);
        // if (!stampaOffline.success) {
        const message = stampa.error || stampa.message || t('tableMapPage.error_print_1');
        throw new Error(message);
        // }
      }
    } catch (err) {
      handleAlert(err.error || err.message || t('tableMapPage.unknown_error'), "error")
    }
  }

  async function executeTransferOrder(ordineDaTrasferire) {
    const updateTable = tavoloFiltrato.filter((ord) => ord.id !== ordineDaTrasferire.id);
    const tableLeft = updateTable?.filter(ord => ord.orderId === ordineDaTrasferire.orderId) || [];

    const newOrder = {
      tableId: selectedTransferTo,
      clientId: ordineDaTrasferire.clientId ?? null,
      totalDiscount: 0,
      products: [
        {
          productId: parseInt(ordineDaTrasferire.product.id),
          variantIds: getVariantIdsForOrderProduct(ordineDaTrasferire),
          quantity: parseFloat(ordineDaTrasferire.quantity)
        }
      ]
    };

    await claimTableSession(Number(selectedTransferTo), token, tenant);

    if (tableLeft.length < 1) {
      await eliminaComanda(ordineDaTrasferire.orderId, token, tenant);
    } else if (tableLeft.length > 0) {
      await spostaProdottiComanda(
        ordineDaTrasferire.orderId,
        tableLeft.map(p => ({
          productId: p.productId,
          variantIds: getVariantIdsForOrderProduct(p),
          quantity: p.quantity,
        })),
        token,
        tenant
      );
    } else {
      throw new Error(t("tableMapPage.error_transfer_order_1"));
    }

    await creaComanda(newOrder, token, tenant);

    if (updateTable.length === 0) {
      await aggiornaTavolo(selectedTavolo.id, { status: "LIBERO" }, token, tenant);
      await releaseTableSession(selectedTavolo.id, token, tenant);
      handleCloseTransferModal();
    }

    window.dispatchEvent(new CustomEvent('comanda-creata'));
  }

  async function handleTransferOrders(ordineDaTrasferire, forceTransfer = false) {
    if (transferLockRef.current) return;
    transferLockRef.current = true;
    try {
      setIsTransferringOrder(true);
      if (!selectedTavolo) {
        throw new Error("Tavolo da cui trasferire non trovato") //da tradurre
      }
      if (!selectedTransferTo) {
        throw new Error("Tavolo in cui trasferire non trovato") //da tradurre
      }
      const destinationTable = (allTables || []).find((tb) => Number(tb.id) === Number(selectedTransferTo));
      if (!forceTransfer && destinationTable?.status === "OCCUPATO") {
        setPendingTransferOrderItem(ordineDaTrasferire);
        setOpenTransferConfirm(true);
        return;
      }

      await executeTransferOrder(ordineDaTrasferire);
    } catch (err) {
      handleAlert(err.message, err?.status === 409 ? "warning" : "error")
    } finally {
      setIsTransferringOrder(false);
      transferLockRef.current = false;
    }
  }

  async function handleAdvancePayment() {
    const activeOrders = (selectedTavolo?.ordersCreatedAt || [])
      .filter((order) => order.status !== 'CLOSED' && order.status !== 'PAID')
      .sort(compareOrdersByCourse);
    if (!activeOrders.length) {
      handleAlert(t('reservations_details.noOrder'), "warning");
      return;
    }

    try {
      const settings = await getTenantSettings(token, tenant);
      const draftPrinterTargets = Array.isArray(settings?.draftPrinterTargets)
        ? [...new Set(settings.draftPrinterTargets.map((name) => String(name || '').trim()).filter(Boolean))]
        : [];

      if (!draftPrinterTargets.length) {
        handleAlert('Nessuna stampante preconto configurata in Impostazioni Sistema', "error");
        return;
      }

      const tableName = selectedTavolo?.name || '';
      const customerName = selectedTavolo?.nomeCliente || '';
      let total = 0;

      const courseGroups = new Map();
      const ensureCourse = (courseIndex, courseName = '') => {
        const normalizedIndex = Math.max(1, Math.trunc(Number(courseIndex || 1) || 1));
        if (!courseGroups.has(normalizedIndex)) {
          courseGroups.set(normalizedIndex, { name: courseName, rows: [] });
        } else if (!courseGroups.get(normalizedIndex).name && courseName) {
          courseGroups.get(normalizedIndex).name = courseName;
        }
        return courseGroups.get(normalizedIndex);
      };
      const addCourseRow = (courseIndex, courseName, row) => {
        ensureCourse(courseIndex, courseName).rows.push(row);
      };

      activeOrders.forEach((order, orderIndex) => {
        const orderCourseIndex = orderIndex + 1;

        (Array.isArray(order?.orderProducts) ? order.orderProducts : []).forEach((op) => {
          const qty = Number(op?.quantity || 0);
          const unit = Number(op?.unitPrice ?? op?.product?.price ?? 0);
          const rowTotal = qty * unit;
          const variantNames = Array.isArray(op?.orderProductVariants)
            ? op.orderProductVariants.map((entry) => entry?.variant?.name).filter(Boolean)
            : [];
          const variantSuffix = variantNames.length ? ` + ${variantNames.join(' + ')}` : '';
          const quantityLabel = formatQuantityWithUnit(qty, op?.product);
          total += rowTotal;
          addCourseRow(
            orderCourseIndex,
            '',
            {
              quantity: quantityLabel,
              description: `${op?.productNameSnapshot || op?.product?.name || '-'}${variantSuffix}`,
              amount: rowTotal,
            }
          );
        });

        (Array.isArray(order?.orderPackages) ? order.orderPackages : []).forEach((pk) => {
          const qty = Number(pk?.quantity || 0);
          const unit = Number(pk?.unitPrice ?? pk?.package?.price ?? 0);
          const rowTotal = qty * unit;
          const packageName = pk?.package?.name || '-';
          total += rowTotal;

          if (isTastingMenuPackage(pk)) {
            addCourseRow(
              orderCourseIndex,
              '',
              {
                quantity: qty,
                description: `[MENU DEGUSTAZIONE] ${packageName}`,
                amount: rowTotal,
              }
            );

            getTastingMenuCourses(pk).forEach((course) => {
              course.items.forEach((item) => {
                const variantSuffix = item?.variantName ? ` + ${item.variantName}` : '';
                addCourseRow(
                  course.courseIndex,
                  course.courseName,
                  {
                    quantity: item?.quantity || 0,
                    description: `${item?.name || '-'}${variantSuffix} [${packageName}]`,
                  }
                );
              });
            });
            return;
          }

          addCourseRow(
            orderCourseIndex,
            '',
            {
              quantity: qty,
              description: `[PACCHETTO] ${packageName}`,
              amount: rowTotal,
            }
          );
        });

        (Array.isArray(order?.orderFixedPriceMenus) ? order.orderFixedPriceMenus : []).forEach((menuRow) => {
          const qty = Number(menuRow?.quantity || 1);
          const unit = Number(menuRow?.finalPrice ?? menuRow?.basePriceSnapshot ?? 0);
          const rowTotal = unit * qty;
          const menuName = menuRow?.menuNameSnapshot || t('fixedPriceMenu.menuFallback');
          total += rowTotal;

          addCourseRow(
            orderCourseIndex,
            '',
            {
              quantity: qty,
              description: `[MENU PREZZO FISSO] ${menuName}`,
              amount: rowTotal,
            }
          );

          getFixedPriceMenuCourses(menuRow).forEach((course) => {
            course.items.forEach((item) => {
              const extraPrice = Number(item?.extraPrice || 0);
              addCourseRow(
                course.courseIndex,
                course.courseName,
                {
                  quantity: item?.quantity || 0,
                  description: `${item?.name || '-'} [${menuName}]`,
                  details: extraPrice > 0
                    ? [{ label: 'Supplemento', amount: extraPrice }]
                    : [],
                }
              );
            });
          });
        });
      });

      const courses = [...courseGroups.entries()]
        .sort(([a], [b]) => a - b)
        .map(([courseIndex, group]) => ({
          index: courseIndex,
          name: group.name,
          rows: group.rows,
        }));

      const draftContent = {
        kind: 'DRAFT_PAYMENT',
        fontSize: settings?.orderPrintFontSize || 'NORMAL',
        title: 'TIPO STAMPA: PRECONTO',
        tableName,
        customerName,
        date: formatDateTime24(new Date()),
        courses,
        total,
      };

      const printTargets = draftPrinterTargets.map((printerName) => ({
        printerName,
        content: draftContent,
      }));

      const payload = { targets: printTargets, action: 'draft_payment' }
      const stampa = await draftPayment(payload, token, tenant);
      if (!stampa.success) {
        const message = stampa.error || stampa.message || t('tableMapPage.error_print_1');
        throw new Error(message);
      }
    } catch (err) {
      handleAlert(err.error || err.message || t('tableMapPage.unknown_error'), "error")
    }
  }
  function handleCrmClient() {
    console.log(t("miscUi.orderReprinted"));
  }

  function handleRoomChargeCheckout() {
    const activeOrders = (selectedTavolo?.ordersCreatedAt || [])
      .filter((order) => order.status !== 'CLOSED' && order.status !== 'PAID');
    if (!selectedTavolo?.id || activeOrders.length === 0) {
      handleAlert(t('reservations_details.noOrder'), "warning");
      return;
    }

    navigate(`/punto_cassa?tableId=${Number(selectedTavolo.id)}&payment=room_charge`, {
      state: {
        checkoutTableId: Number(selectedTavolo.id),
        roomChargeShortcut: true,
      },
    });
  }

  function handleSeeOrders() {
    console.log(t("miscUi.viewOrder"));
  }

  function formatDate(date) {
    const d = new Date(date)
    d.setHours(0, 0, 0, 0)
    return d.toString()
  }

  function handleAlert(msg, type) {
    showSnackbar(msg, type)
  }

  function handleCloseTransferModal() {
    if (isTransferringOrder) return;
    setSelectedTransferTo("")
    setOpenTransferConfirm(false)
    setPendingTransferOrderItem(null)
    setOpenTransfer(false)
  }

  const actionButtonSx = useMemo(() => ({
    px: 1.25,
    gap: 0.75,
    borderRadius: "8px",
    minHeight: 34,
    flex: { xs: "1 1 calc(50% - 4px)", sm: "0 0 auto" },
    minWidth: { xs: 0, sm: "auto" },
    fontSize: { xs: "0.72rem", sm: "0.8125rem" },
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": {
      fontSize: { xs: 18, sm: 20 },
    },
    border: theme.palette.mode === "light"
      ? "1px solid rgba(0, 0, 0, 0.25)"
      : "1px solid rgba(255, 255, 255, 0.28)",
    backgroundColor: theme.palette.mode === "light" ? "#FAFAFA" : "#22272F",
    color: theme.palette.mode === "light" ? "#131313" : "#F5F7FA",
    "&:hover": {
      backgroundColor: theme.palette.mode === "light" ? "#F0F0F0" : "#2D3440",
    },
    "&.Mui-disabled": {
      color: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.35)" : "rgba(255, 255, 255, 0.45)",
      borderColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.14)",
      backgroundColor: theme.palette.mode === "light" ? "#F4F4F4" : "#1A1E24",
    },
  }), [theme.palette.mode]);

  const flowControlsSx = useMemo(() => ({
    "& .react-flow__controls": {
      border: theme.palette.mode === "light"
        ? "1px solid rgba(0, 0, 0, 0.18)"
        : "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "none",
      backgroundColor: theme.palette.mode === "light" ? "#FAFAFA" : "#1E232B",
    },
    "& .react-flow__controls-button": {
      width: 28,
      height: 28,
      backgroundColor: theme.palette.mode === "light" ? "#FAFAFA" : "#1E232B",
      borderBottom: theme.palette.mode === "light"
        ? "1px solid rgba(0, 0, 0, 0.12)"
        : "1px solid rgba(255, 255, 255, 0.16)",
      color: theme.palette.mode === "light" ? "#131313" : "#F5F7FA",
    },
    "& .react-flow__controls-button:hover": {
      backgroundColor: theme.palette.mode === "light" ? "#F0F0F0" : "#2A313D",
    },
    "& .react-flow__controls-button svg": {
      fill: theme.palette.mode === "light" ? "#131313" : "#F5F7FA",
    },
  }), [theme.palette.mode]);

  const lockMainY = useCallback(() => {
    const instance = mainFlowRef.current;
    if (!instance) return;
    mainLockedYRef.current = instance.getViewport().y;
  }, []);

  const fitMainFlowToNodes = useCallback(() => {
    const instance = mainFlowRef.current;
    if (!instance || !nodes?.length) return;

    isMainAutoFittingRef.current = true;
    if (isCompactDetailed) {
      const targetNode = nodes.find((node) => Number(node.id) === Number(selectedTavolo?.id)) || nodes[0];
      Promise.resolve(
        instance.setCenter(
          targetNode.position.x + 64,
          targetNode.position.y + 52,
          { zoom: 1.15, duration: 0 }
        )
      ).finally(() => {
        requestAnimationFrame(() => {
          lockMainY();
          isMainAutoFittingRef.current = false;
        });
      });
      return;
    }

    Promise.resolve(
      instance.fitView({
        padding: 0.24,
        duration: 0,
        includeHiddenNodes: true,
        minZoom: 0.35,
        maxZoom: 1.2,
      })
    ).finally(() => {
      requestAnimationFrame(() => {
        lockMainY();
        isMainAutoFittingRef.current = false;
      });
    });
  }, [isCompactDetailed, nodes, selectedTavolo?.id, lockMainY]);

  const handleMainFlowInit = useCallback((instance) => {
    mainFlowRef.current = instance;
    fitMainFlowToNodes();
  }, [fitMainFlowToNodes]);

  useEffect(() => {
    if (!mainFlowRef.current || !nodes?.length) return;
    const currentCount = nodes.length;
    const currentSignature = nodes
      .map((n) => `${n.id}:${Math.round(n.position.x)}:${Math.round(n.position.y)}`)
      .sort()
      .join("|");
    const shouldFit =
      prevMainNodesCountRef.current === null ||
      prevMainNodesCountRef.current !== currentCount ||
      prevMainNodesSignatureRef.current !== currentSignature;
    prevMainNodesCountRef.current = currentCount;
    prevMainNodesSignatureRef.current = currentSignature;
    if (!shouldFit) return;

    const timer = setTimeout(() => {
      fitMainFlowToNodes();
    }, 0);

    return () => clearTimeout(timer);
  }, [nodes, fitMainFlowToNodes]);

  const handleMainFlowMoveStart = useCallback(() => {
    if (isMainAutoFittingRef.current) return;
    lockMainY();
  }, [lockMainY]);

  const handleEditFlowInit = useCallback((instance) => {
    editFlowRef.current = instance;
  }, []);

  const fitEditFlowToNodes = useCallback(() => {
    const instance = editFlowRef.current;
    if (!instance || !editOpen || editNodes.length === 0) return;

    requestAnimationFrame(() => {
      instance.fitView({
        padding: 0.24,
        duration: 0,
        includeHiddenNodes: true,
        minZoom: 0.35,
        maxZoom: 1.2,
      });
    });
  }, [editOpen, editNodes.length]);

  useEffect(() => {
    if (!editOpen || editNodes.length === 0) return;
    const immediateTimer = setTimeout(() => fitEditFlowToNodes(), 0);
    const postTransitionTimer = setTimeout(() => fitEditFlowToNodes(), 180);

    return () => {
      clearTimeout(immediateTimer);
      clearTimeout(postTransitionTimer);
    };
  }, [editOpen, editNodes.length, fitEditFlowToNodes]);

  const handleMainFlowMove = useCallback((_, viewport) => {
    if (isMainAutoFittingRef.current) return;
    const instance = mainFlowRef.current;
    const lockedY = mainLockedYRef.current;
    if (!instance || lockedY === null || syncingMainViewportRef.current) return;
    if (Math.abs(viewport.y - lockedY) < 0.1) return;

    syncingMainViewportRef.current = true;
    Promise.resolve(
      instance.setViewport({ x: viewport.x, y: lockedY, zoom: viewport.zoom }, { duration: 0 })
    ).finally(() => {
      syncingMainViewportRef.current = false;
    });
  }, []);

  const handleEditNodesChange = useCallback((changes) => {
    setEditNodes((currentNodes) => applyNodeChanges(changes, currentNodes));
  }, [setEditNodes]);

  if (isCompactDetailed) {
    return (
      <>
        <Box display="flex" gap={1} flexWrap="wrap" sx={{ width: "100%", mb: 1.5 }}>
          <Button variant="alt" sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size="small" onClick={() => { handlePrint() }}>
            <PrintOutlinedIcon /> {t("tableMapPage.print")}
          </Button>
          <Button variant="alt" sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size="small" onClick={() => { handleAdvancePayment() }}>
            <EuroOutlinedIcon /> {t("tableMapPage.draftPayment")}
          </Button>
          <Button variant="alt" sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size="small" onClick={handleRoomChargeCheckout}>
            <HotelOutlinedIcon /> {t("tableMapPage.roomChargeCheckout", { defaultValue: "Addebito camera" })}
          </Button>
          <Button variant="alt" sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size="small" onClick={() => { handleCrmClient() }}>
            <StorageOutlinedIcon /> {t("tableMapPage.CRMclients")}
          </Button>
          <Button variant="alt" sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size="small" onClick={() => { handleSeeOrders() }}>
            <EditNoteOutlinedIcon /> {t("tableMapPage.seeOrders")}
          </Button>
        </Box>

        <Grid
          container
          spacing={1.2}
          sx={{
            mb: 2,
            touchAction: "pan-y",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {tavoliDettagliati.map((tavolo) => (
            <Grid item xs={6} sm={4} key={tavolo.id}>
              <MobileTavoloCard
                tavolo={tavolo}
                selected={Number(selectedTavolo?.id) === Number(tavolo.id)}
                onSelect={setSelectedTavolo}
                getColor={getColor}
              />
            </Grid>
          ))}
        </Grid>

        {selectedTavolo ? (
          <Box
            sx={{
              width: "100%",
              maxHeight: "70dvh",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              backgroundColor: theme.pannelloDettagli.backgroundColor,
              borderRadius: 2,
            }}
          >
            <PannelloDettagli
              sx={{ flexGrow: 1 }}
              tavoloId={selectedTavolo?.id}
              tavoli={tavoliDettagliati}
              onClose={() => setSelectedTavolo(null)}
              categorie={categorie}
              sottoCategorie={sottoCategorie}
              onOpenComanda={() => setOpenComanda(true)}
              onCanOpenTableOrder={onCanOpenTableOrder}
            />
          </Box>
        ) : (
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              textAlign: "center",
              color: "text.secondary",
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Typography>{t("noTableSelected")}</Typography>
          </Paper>
        )}

        <Dialog
          open={openComanda}
          fullWidth
          maxWidth={false}
          PaperProps={{
            sx: {
              width: "calc(100vw - 8px)",
              maxWidth: "calc(100vw - 8px)",
              height: "calc(100dvh - 8px)",
              maxHeight: "calc(100dvh - 8px)",
              m: 0.5,
              borderRadius: 2,
            },
          }}
          onClose={() => setOpenComanda(false)}
        >
          <DialogContent sx={{ paddingBottom: 0, paddingTop: 0, minHeight: 0, display: "flex", flexDirection: "column", overflowY: "hidden", overflowX: "hidden", touchAction: "pan-x pan-y pinch-zoom", WebkitOverflowScrolling: "touch" }}>
            <SelezioneComanda
              open={openComanda}
              tavolo={selectedTavolo}
              onClose={() => setOpenComanda(false)}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  }

  return (
    <>
      {/* mostra solo se c'è un tavolo selezionato e se quel tavolo ha ordinazioni */}
      <Box display={"flex"} gap={1} flexWrap={"wrap"} sx={{ width: "100%", mb: { xs: 1.5, md: 0 } }}>
        <Button variant='alt' sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size='small' onClick={() => { handlePrint() }}><PrintOutlinedIcon />      {t("tableMapPage.print")}    </Button>
        <Button variant='alt' sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size='small' onClick={() => { handleAdvancePayment() }}><EuroOutlinedIcon />       {t("tableMapPage.draftPayment")}  </Button>
        <Button variant='alt' sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size='small' onClick={handleRoomChargeCheckout}><HotelOutlinedIcon />       {t("tableMapPage.roomChargeCheckout", { defaultValue: "Addebito camera" })}  </Button>
        <Button variant='alt' sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size='small' onClick={() => { handleCrmClient() }}><StorageOutlinedIcon />    {t("tableMapPage.CRMclients")}      </Button>
        <Button variant='alt' sx={actionButtonSx} disabled={!selectedTavolo || selectedTavolo.status !== "OCCUPATO"} size='small' onClick={() => { handleSeeOrders() }}><EditNoteOutlinedIcon />   {t("tableMapPage.seeOrders")}       </Button>
      </Box>
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: 1.5, md: 0 }, mr: { xs: 0, md: 2 }, mt: { xs: 1, md: 2 }, minWidth: 0 }}>
        {/* Mappa tavoli */}
        <Box sx={{ flexGrow: 1, width: "100%", minWidth: 0, height: { xs: "420px", sm: "500px", md: "643px" }, position: "relative", border: theme.palette.accordion.border, borderRadius: 2, overflow: "hidden", touchAction: hasCoarsePointer ? "pan-y" : "auto", ...flowControlsSx }}>
          <ReactFlowProvider>
            <ReactFlow
              nodes={nodes}
              edges={edges}
              nodeTypes={nodeTypes}
              onInit={handleMainFlowInit}
              onMoveStart={handleMainFlowMoveStart}
              onMove={handleMainFlowMove}
              panOnScroll
              panOnScrollMode={PanOnScrollMode.Horizontal}
              panOnDrag={!hasCoarsePointer}
              preventScrolling={!hasCoarsePointer}
              nodesDraggable={false}
              nodesConnectable={false}
              zoomOnPinch
              style={{ touchAction: hasCoarsePointer ? "pan-y" : "none" }}
            >
              <Background />
              <Controls style={{ color: theme.palette.mode === "light" ? "#131313" : "#F5F7FA" }} />
            </ReactFlow>
          </ReactFlowProvider>

          <Button
            variant="contained"
            sx={{ position: "absolute", bottom: 10, right: 8, maxWidth: { xs: "calc(100% - 16px)", sm: "auto" } }}
            onClick={handleOpenEdit}
          >
            {t("editLayout")}
          </Button>
        </Box>

        {/* Colonna destra */}
        {(!isCompactDetailed || selectedTavolo) && (
          <Box
            sx={{
              width: { xs: "100%", md: "auto" },
              minWidth: { xs: 0, md: 320 },
              height: { xs: "auto", md: "643px" },
              maxHeight: { xs: "70dvh", md: "643px" },
              ml: { xs: 0, md: 2 },
              display: "flex",
              flexDirection: "column",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              backgroundColor: theme.pannelloDettagli.backgroundColor,
              borderRadius: { xs: 2, md: 0 },
            }}
          >
            <PannelloDettagli sx={{ flexGrow: 1 }}
              tavoloId={selectedTavolo?.id}
              tavoli={tavoliDettagliati}
              onClose={() => setSelectedTavolo(null)}
              categorie={categorie}
              sottoCategorie={sottoCategorie}
              onOpenComanda={() => setOpenComanda(true)}
              onCanOpenTableOrder={onCanOpenTableOrder}
            />
          </Box>
        )}

        <Dialog
          open={editOpen}
          onClose={(_, reason) => {
            if (isSavingLayout && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return;
            if (!isSavingLayout) setEditOpen(false);
          }}
          TransitionProps={{
            onEntered: fitEditFlowToNodes,
          }}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>{t("editLayoutTitle")}</DialogTitle>
          <DialogContent sx={{ height: 500, ...flowControlsSx }}>
            <ReactFlowProvider>
              <ReactFlow
                nodes={editNodes.map(node => ({
                  ...node,
                  data: { ...node.data, hideButton: true } //nascondo i bottoni di ogni tavolo
                }))}
                edges={[]}
                onNodesChange={handleEditNodesChange}
                nodeTypes={nodeTypes}
                fitView
                onInit={handleEditFlowInit}
                panOnScroll
                panOnScrollMode={PanOnScrollMode.Free}
                panOnDrag={true}
                nodesDraggable={true}
                nodesConnectable={false}
                zoomOnPinch
              >
                <Background />
                <Controls />
              </ReactFlow>
            </ReactFlowProvider>
          </DialogContent>
          <DialogActions>
            <Button disabled={isSavingLayout} onClick={() => setEditOpen(false)}>{t("cancel")}</Button>
            <Button disabled={isSavingLayout} variant="contained" onClick={handleSave}>
              {isSavingLayout ? <CircularProgress size={18} color="inherit" /> : t("save")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openComanda}
          fullWidth
          maxWidth={false}
          PaperProps={{
            sx: {
              width: { xs: 'calc(100vw - 8px)', md: '95vw' },
              maxWidth: '1800px',
              height: { xs: 'calc(100dvh - 8px)', md: 'auto' },
              maxHeight: { xs: 'calc(100dvh - 8px)', md: 'calc(100dvh - 32px)' },
              m: { xs: 0.5, md: 2 },
              borderRadius: 2,
            },
          }}
          onClose={() => setOpenComanda(false)}
        >
          <DialogContent sx={{ paddingBottom: 0, paddingTop: 0, minHeight: 0, display: 'flex', flexDirection: 'column', overflowY: 'hidden', overflowX: 'hidden', touchAction: 'pan-x pan-y pinch-zoom', WebkitOverflowScrolling: 'touch' }}>
            <SelezioneComanda
              open={openComanda}
              tavolo={selectedTavolo}
              onClose={() => setOpenComanda(false)}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={openTransfer}
          fullWidth
          height={"120px"}
          onClose={(_, reason) => {
            if (isTransferringOrder && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return;
            handleCloseTransferModal();
          }}
        >
          <DialogTitle>{t("tableMapPage.transferOrders")}</DialogTitle>
          <DialogContent sx={{ overflowY: 'hidden' }}>
            <Grid container columnSpacing={2} rowSpacing={1}>
              <Grid item size={6}>
                {/* select per selezionare il tavolo DA cui trasferire l'ordine */}
                <Typography>{t("tableMapPage.transferFrom")}</Typography>
                <Select
                  id="SelectedTranferFrom"
                  value={selectedTavolo?.id}
                  disabled
                  variant="outlined"
                  size="small"
                  renderValue={(selected) => {
                    if (!selected) {
                      return <span style={{ color: '#888' }}>{t('selectTable')}</span>;
                    }
                    const value = allTables?.find((tab) => tab.id === selected);
                    return value?.name;
                  }}
                  sx={theme.checkout.orange_outline_button}
                >
                  <MenuItem key={selectedTavolo?.id} value={selectedTavolo?.id}>{selectedTavolo?.name}</MenuItem>
                </Select>
              </Grid>
              {/* select per selezionare il tavolo A cui trasferire l'ordine */}
              <Grid item size={6}>
                <Typography>{t("tableMapPage.transferTo")}</Typography>
                <Select
                  id="SelectedTranferTo"
                  value={selectedTransferTo}
                  onChange={(e) => { setSelectedTransferTo(e.target.value) }}
                  disabled={isTransferringOrder}
                  displayEmpty
                  variant="outlined"
                  size="small"
                  renderValue={(selected) => {
                    if (!selected) {
                      return <span style={{ color: '#888' }}>{t('selectTable')}</span>;
                    }
                    const value = allTables?.find((tab) => tab.id === selected);
                    return value?.name;
                  }}
                  sx={theme.checkout.orange_outline_button}
                >
                  <MenuItem key={"null"} value={""}>{t('selectTable')}</MenuItem>
                  {allTables.filter((tb) => (!selectedTavolo || tb.id !== selectedTavolo.id)).map((tb) => (<MenuItem key={tb.id} value={tb.id}>{tb.name}</MenuItem>))}
                </Select>
              </Grid>
              <Grid item size={12}>
                <TextField
                  size="small"
                  value={searchOrders}
                  onChange={(e) => { setSearchOrders(e.target.value) }}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />
              </Grid>
              <Grid container item size={24} sx={{ overflow: "hidden", minHeight: "80px", maxHeight: "300px" }}>
                <Paper sx={{ minHeight: "80px", maxHeight: "stretch", overflowY: "auto", width: "400px" }}>{/*WIP*/}
                  <Box flexGrow={1} paddingRight={"6px"} sx={{ backgroundColor: theme.pannelloDettagli.backgroundColor }}>
                    {selectedTavolo ? (
                      <Box>
                        {selectedTavolo.status === "LIBERO" && tavoloFiltrato.length > 0 ?
                          (
                            <Box
                              sx={{
                                borderRadius: 1,
                                marginTop: 1,
                                minHeight: "74px",
                                display: "flex",
                                justifyContent: "center",
                                border: theme.palette.accordion.border,
                                backgroundColor: theme.palette.accordion.backgroundColor
                              }}>
                              <Typography variant="h5" color="text.secondary" sx={{ alignContent: "center" }}>
                                {t('reservations_details.noOrder')}
                              </Typography>

                            </Box>
                          ) :
                          tavoloFiltrato && tavoloFiltrato.length > 0 ?
                            (
                              tavoloFiltrato
                                ?.filter((prod) =>
                                  (prod?.product?.name || "")
                                    .toLowerCase()
                                    .includes(searchOrders.toLowerCase())
                                )
                                .map((prodotto, index) => (
                                    <Box
                                      key={`${prodotto.orderId}-${prodotto.productId}-${index}`}
                                      sx={{
                                        // minHeight: '90px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        mb: 1,
                                        p: 2,
                                        pt: 2,
                                        pb: 2,
                                        border: theme.palette.accordion.border,
                                        borderRadius: '4px',
                                        backgroundColor: theme.palette.background.default,
                                      }}
                                    >
                                      <Typography variant="body2" pt={'1px'} pb={'1px'} fontStyle={"italic"} alignContent="center">[x{prodotto?.quantity}] {prodotto.product?.name}</Typography>
                                      <Button variant="contained"
                                        disabled={isTransferringOrder}
                                        onClick={() => { handleTransferOrders(prodotto) }}
                                      >
                                        {isTransferringOrder
                                          ? <CircularProgress size={18} color="inherit" />
                                          : t("tableMapPage.transferButton")}
                                      </Button>
                                    </Box>
                                  ))

                            )
                            :
                            (
                              <Box
                                sx={{
                                  borderRadius: 1,
                                  marginTop: 1,
                                  minHeight: "74px",
                                  display: "flex",
                                  justifyContent: "center",
                                  border: theme.palette.accordion.border,
                                  backgroundColor: theme.palette.accordion.backgroundColor
                                }}>
                                <Typography variant="h5" color="text.secondary" sx={{ alignContent: "center" }}>
                                  {t('reservations_details.noOrder')}
                                </Typography>

                              </Box>
                            )
                        }
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          flexGrow: 1,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "text.secondary",
                        }}
                      >
                        <Typography variant="h6" textAlign={"center"}>
                          {t("noTableSelected")}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button disabled={isTransferringOrder} onClick={() => { handleCloseTransferModal() }} color="secondary" variant="outlined">
              {t('cancel')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openTransferConfirm}
          onClose={(_, reason) => {
            if (isTransferringOrder && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return;
            setOpenTransferConfirm(false);
            setPendingTransferOrderItem(null);
          }}
        >
          <DialogTitle>{t("tableMapPage.transferOrders")}</DialogTitle>
          <DialogContent>
            <Typography>
              {t("miscUi.occupiedDestinationTableConfirm")}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={isTransferringOrder}
              onClick={() => {
                setOpenTransferConfirm(false);
                setPendingTransferOrderItem(null);
              }}
              color="secondary"
              variant="outlined"
            >
              {t('cancel')}
            </Button>
            <Button
              disabled={isTransferringOrder}
              onClick={async () => {
                const itemToTransfer = pendingTransferOrderItem;
                setOpenTransferConfirm(false);
                setPendingTransferOrderItem(null);
                if (itemToTransfer) {
                  await handleTransferOrders(itemToTransfer, true);
                }
              }}
              variant="contained"
            >
              {t('confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      </Box >
    </>
  );
};

export default VistaDettagliata;




